import { ComponentProps, FC, useContext } from 'react'
import { ErrorText } from '../../ErrorText'
import { FormContext } from '../FormContext'

export const FormErrorText: FC<{ name: string } & ComponentProps<typeof ErrorText>> = (props) => {
  const formContext = useContext(FormContext)

  if (!formContext.errors[props.name]) return null
  return <ErrorText {...props}>{formContext.errors[props.name]}</ErrorText>
}
